<template>
    <div>
        <div v-if="row.status === 1 || row.status === 0">
            <el-button-group class="pcgl-btn">
                <el-button v-pageBtn-lbl="'dispatchCar'" type="text" class="clgl-sendcar" @click="sendsCar">派车</el-button>
                <el-button v-pageBtn-lbl="'refuse'" type="text" class="clgl-sendcar" @click="rejectDeliver">拒绝</el-button>
            </el-button-group>
        </div>
        <div v-if="row.status === 2">
            <el-button v-pageBtn-lbl="'cancel'" type="text" class="clgl-sendcar" @click="cancelCar">取消</el-button>
        </div>
        <div v-if="row.status === 3">
            <el-button-group class="pcgl-btn">
                <el-button v-pageBtn-lbl="'delay'" type="text" class="clgl-sendcar" @click="delayCar($scope, row)">延期</el-button>
                <el-button v-pageBtn-lbl="'ReturnCar'" type="text" class="clgl-sendcar" @click="backCar($scope, row)">还车</el-button>
            </el-button-group>
        </div>
        <div v-if="editBtn">
            <el-button v-pageBtn-lbl="'update'" type="text" class="clgl-sendcar" @click="editCar($scope, row)">修改</el-button>
        </div>
        <div v-if="row.status === 5 || row.status === 9 || (!editBtn && row.status === 4)">
            <el-button v-pageBtn-lbl="'look'" type="text" class="clgl-sendcar" @click="showForm($scope, row)">查看</el-button>
        </div>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    props: {
        column: { type: Object, default: null },
        row: { type: Object, default: null },
        index: { type: Number, default: null }
    },
    data() {
        return {
            i18npkg: 'clgl',
            moduleCode: 'pcgl',
            editBtn: false,
            editInterval: ''
        }
    },
    watch: {
        row: {
            immediate: true,
            handler: function (val) {
                this.getEditBtn()
                if (val.status === 4) {
                    this.editInterval = setInterval(this.getEditBtn, 1000)
                }
            },
            deep: true
        }
    },
    created() {},
    mounted() {},
    beforeDestroy() {
        clearInterval(this.editInterval)
    },
    methods: {
        // 查看
        showForm($scope, row) {
            const _this = this.$vnode.context.$vnode.context
            if (row.draveType === 1) {
                // 如果是随车类型，显示司机信息
                // this.$vnode.context.moduleInfo.controldraveTypeHide = true
                _this.moduleInfo.controldraveTypeHide = true
            } else {
                // this.$vnode.context.moduleInfo.controldraveTypeHide = false
                _this.moduleInfo.controldraveTypeHide = false
            }
            // this.$vnode.context.moduleInfo.sendcar = []
            // this.$vnode.context.moduleInfo.moment = moment
            // this.$vnode.context.moduleInfo.sendcar = []
            // this.$vnode.context.moduleInfo.moment = moment
            _this.moduleInfo.sendcar = []
            _this.moduleInfo.moment = moment
            this.$vnode.context.$vnode.context.formTitle = this.$tx('clgl.pcgl.directgl', '派车管理')
            this.$vnode.context.$parent.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: 'default'
                }
                // ,
                // {
                //     id: 'btn_update',
                //     btnName: '确 定',
                //     btnIcon: 'check',
                //     btnClick: 'submitBusiform',
                //     btnPermission: 'saveObject',
                //     btnType: 'primary'
                // }
            ]
            this.$bus.emit('openBusiform', _this.moduleInfo, this.row, 0, () => {
                this.$vnode.context.$vnode.context.formTitle = this.$tx('clgl.pcgl.directVehicles', '直接派车')
            })
        },
        /**
         * 派车
         */
        sendsCar() {
            const _this = this.$vnode.context.$vnode.context
            _this.$options.components['BusiForm'] = _this.$loadComponent('#/dcontent/vuebusiform/W/clgl.sendcar.form_sendacerbt.vue?sysCode=' + _this.$route.meta.sysCode)
            // this.$vnode.context.moduleInfo.sendcar = ['pcType']
            // this.$vnode.context.moduleInfo.moment = moment
            _this.moduleInfo.sendcar = ['pcType']
            _this.moduleInfo.moment = moment
            this.$vnode.context.$parent.formTitle = this.$tx('clgl.pageBtns.dispatchCar', '派车')
            _this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: this.$tx('pageBtns.cancel', '取消'),
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: 'default'
                },
                {
                    id: 'btn_update',
                    btnName: this.$tx('pageBtns.sure', '确定'),
                    btnIcon: 'check',
                    btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary'
                }
            ]
            // this.$vnode.context.$parent.onBasicFormBeforeSubmit = function ($scope, vo, defer) {
            //     vo.status = 2
            //     defer.resolve(true)
            // }
            _this.moduleInfo.subType = '派车'

            _this.$bus.emit('openBusiform', _this.moduleInfo, this.row, 1, (res) => {
                if (res.code === 'success') {
                    this.$message.success('保存成功。')
                }
                delete _this.moduleInfo.subType

                _this.$options.components['BusiForm'] = _this.$loadComponent('#/dcontent/vuebusiform/W/clgl.sendcar.form.vue?sysCode=' + _this.$route.meta.sysCode)
                this.$vnode.context.$parent.formTitle = this.$tx('clgl.pcgl.dispatchCar', '派车')
            })
        },
        /**
         * 延期还车
         */
        delayCar($scope, row) {
            const moduleInfo = this.$vnode.context.$vnode.context.moduleInfo
            if (row.draveType === 1) {
                console.log('33333333333')
                // 如果是随车类型，显示司机信息
                moduleInfo.controldraveTypeHide = true
            } else {
                moduleInfo.controldraveTypeHide = false
            }
            const _this = this.$vnode.context.$vnode.context
            _this.$options.components['BusiForm'] = _this.$loadComponent('#/dcontent/vuebusiform/W/clgl.sendcar.form_sendcar.vue?sysCode=' + _this.$route.meta.sysCode)
            // console.log(this.$vnode.context)
            _this.formTitle = this.$tx('clgl.pcgl.delayCar', '延期还车')
            moduleInfo.moment = moment
            moduleInfo.sendcar = ['ycjsType']

            _this.$parent.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: this.$tx('pageBtns.cancel', '取消'),
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: 'default'
                },
                {
                    id: 'btn_update',
                    btnName: this.$tx('pageBtns.sure', '确定'),
                    btnIcon: 'check',
                    btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary'
                }
            ]
            _this.$bus.emit('openBusiform', _this.moduleInfo, this.row, 1, (res) => {
                _this.$options.components['BusiForm'] = _this.$loadComponent('#/dcontent/vuebusiform/W/clgl.sendcar.form.vue?sysCode=' + _this.$route.meta.sysCode)
                _this.formTitle = this.$tx('clgl.pcgl.zjhCar', '直接还车')
            })
        },
        /**
         * 还车
         */
        backCar($scope, row) {
            if (row.draveType === 1) {
                // 如果是随车类型，显示司机信息
                this.$vnode.context.$vnode.context.moduleInfo.controldraveTypeHide = true
            } else {
                this.$vnode.context.$vnode.context.moduleInfo.controldraveTypeHide = false
            }
            const _this = this.$vnode.context.$vnode.context
            _this.$options.components['BusiForm'] = _this.$loadComponent('#/dcontent/vuebusiform/W/clgl.sendcar.form_sendcar.vue?sysCode=' + _this.$route.meta.sysCode)
            // 上面内容新加
            _this.formTitle = this.$tx('clgl.pcgl.ReturnCar', '还车')
            _this.moduleInfo.moment = moment
            _this.moduleInfo.sendcar = ['sjycType']
            _this.$parent.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: this.$tx('pageBtns.cancel', '取消'),
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: 'default'
                },
                {
                    id: 'btn_update',
                    btnName: this.$tx('pageBtns.sure', '确定'),
                    btnIcon: 'check',
                    btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary'
                }
            ]
            // 新修改
            // this.$bus.emit('openBusiform', this.$parent.$parent.$parent.moduleInfo, this.row, 1)
            _this.$bus.emit('openBusiform', _this.moduleInfo, this.row, 1, (res) => {
                _this.$options.components['BusiForm'] = _this.$loadComponent('#/dcontent/vuebusiform/W/clgl.sendcar.form.vue?sysCode=' + _this.$route.meta.sysCode)
            })
        },
        /**
         * 编辑
         */
        editCar($scope, row) {
            const _this = this.$vnode.context.$vnode.context
            if (row.draveType === 1) {
                // 如果是随车类型，显示司机信息
                _this.moduleInfo.controldraveTypeHide = true
            } else {
                _this.moduleInfo.controldraveTypeHide = false
            }
            _this.$vnode.context.formTitle = this.$tx('pageBtns.update', '修改')
            _this.moduleInfo.moment = moment
            _this.moduleInfo.sendcar = ['editType']
            // 禁用派车管理修改编辑弹框的车牌号操作
            _this.moduleInfo.controlcarEdit = true
            // this.$vnode.context.moduleInfo.moduleCode = 'sendcar'
            _this.$parent.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: this.$tx('pageBtns.cancel', '取消'),
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: 'default'
                },
                {
                    id: 'btn_update',
                    btnName: this.$tx('pageBtns.sure', '确定'),
                    btnIcon: 'check',
                    btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary'
                }
            ]
            console.log(_this.moduleInfo, 'this.$vnode.context.moduleInfo')
            this.$bus.emit('openBusiform', _this.moduleInfo, this.row, 1, () => {
                _this.moduleInfo.controlcarEdit = false
                _this.$vnode.context.formTitle = this.$tx('clgl.pcgl.zjhCar', '直接还车')
            })
        },
        // 取消
        cancelCar() {
            var _this = this
            this.$confirm(this.$tx('clgl.pcgl.cancelCar', '确定要取消派车吗？'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' }).then(() => {
                _this.row.status = 9
                _this
                    .$http({
                        method: 'PUT',
                        url: 'clgl/sendcar/update',
                        data: _this.row
                    })
                    .then((res) => {
                        if (res.code === 'success') {
                            _this.$message.success(res.message)
                            this.$nextTick(() => {
                                _this.$bus.emit('refreshListData')
                            })
                        } else {
                            _this.$message.error(res.message)
                        }
                    })
            })
        },
        /**
         * 拒绝派车
         */
        rejectDeliver() {
            var _this = this
            this.$confirm(this.$tx('clgl.pcgl.refuseCar', '确定要拒绝派车吗？'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' }).then(() => {
                _this.row.status = 5
                this.$http({
                    method: 'PUT',
                    url: 'clgl/sendcar/update',
                    data: _this.row
                }).then((res) => {
                    if (res.code === 'success') {
                        _this.$message.success(this.$tx('clgl.pcgl.refuseCarEd', '已拒绝派车！'))
                        this.$nextTick(() => {
                            _this.$bus.emit('refreshListData')
                        })
                    } else {
                        _this.$message.error(res.message)
                    }
                })
            })
        },
        /**
         * 编辑预判
         */
        getEditBtn() {
            if (this.row.status === 4) {
                var nowDate = moment().format('YYYY,MM,DD,kk,mm,ss').split(',')
                nowDate.splice(1, 1, ('0' + (nowDate[1] - 1)).slice(-2))
                var day = moment(this.row.returnTime).format('YYYY,MM,DD,kk,mm,ss').split(',')
                day.splice(1, 1, ('0' + (day[1] - 1)).slice(-2))
                day = moment(day)
                nowDate = moment(nowDate)
                const str = nowDate.diff(day, 'days')

                if (str === 0) {
                    this.editBtn = true
                } else {
                    this.editBtn = false
                }
            } else {
                this.editBtn = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
.pcgl-btn {
    display: flex;
    justify-content: space-between;
}
.pcgl-btn .el-button {
    padding: 0px 7px;
}
.clgl-sendcar {
    color: #333;
}
.clgl-sendcar:hover {
    color: #409eff;
}
// .pcgl-btn .el-button:first-of-type{
// border-right: 1px solid;
// height: 20px;
// width: 65px;
// text-align: right;
// }
// .pcgl-btn .el-button:last-of-type{
//     text-align: left;
//     width: 60px;
// }
</style>
